import AbstractModel, { Model, DateType } from './abstract-model';

@Model('CavCusActionJuridique')
export default class CavCusActionJuridique extends AbstractModel {
  public id: number = null; //integer
  public idCavite: string = null;
  public actionJuridique: string = null;
  @DateType() public dateAction: Date = null;
  @DateType() public cDateModif: Date = null;
  public cUserModif: string = null;
}

